import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yearsOfServiceBadgeIcon',
})
export class YearsOfServiceBadgeIconPipe implements PipeTransform {
  transform(
    dateEmployment: string | undefined | null,
  ): 'years-of-service-badge-5' | 'years-of-service-badge-10' | 'years-of-service-badge-15' | null {
    let badge:
      | 'years-of-service-badge-5'
      | 'years-of-service-badge-10'
      | 'years-of-service-badge-15'
      | null = null;

    if (dateEmployment) {
      const start = new Date(dateEmployment);

      if (!Number.isNaN(start.getTime())) {
        const now = new Date();

        if (start <= now) {
          const totalMonths =
            (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());

          if (totalMonths >= 180) {
            badge = 'years-of-service-badge-15';
          } else if (totalMonths >= 120) {
            badge = 'years-of-service-badge-10';
          } else if (totalMonths >= 60) {
            badge = 'years-of-service-badge-5';
          }
        }
      }
    }

    return badge;
  }
}
